import { Grid } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { MAP_LAYER_NAMES } from '../../../constants/mapLayerNames';
import { scales, scaleTypes } from '../../../constants/mapLegendNames';
import { getDroughtLegendDefinition } from '../../mapdata/droughtStyleMap';

const getDiscreteLegendEntryStyle = (entry, length) => {
    if (
        entry &&
        typeof entry === 'object' &&
        !Array.isArray(entry) &&
        typeof entry.hex !== 'function'
    ) {
        return {
            width: `${200 / length}px`,
            height: '15px',
            boxSizing: 'border-box',
            backgroundColor: entry.fill,
            border: `${entry.strokeWidth || 1}px solid ${entry.stroke}`,
        };
    }

    return {
        width: `${200 / length}px`,
        height: '15px',
        backgroundColor: typeof entry?.hex === 'function' ? entry.hex() : entry,
    };
};

const Legend = ({ mapName }) => {
    const location = useLocation();
    const droughtLegend =
        mapName === MAP_LAYER_NAMES.DROUGHT
            ? {
                  ...getDroughtLegendDefinition(new URLSearchParams(location.search).get('filter')),
                  type: scaleTypes.DISCRETE,
              }
            : null;
    const legendDefinition = droughtLegend || scales[mapName];

    if (!legendDefinition) {
        return null;
    }

    return (
        <Grid
            container
            style={{
                width: '210px',
                minWidth: '210px',
                padding: '0 5px',
            }}
            spacing={0}
        >
            <Grid
                item
                container
                justifyContent="center"
                sx={{ mb: 0.625, fontSize: '10px', textAlign: 'center' }}
            >
                {legendDefinition.name}
            </Grid>
            <Grid item container sx={{ mb: 0.625 }}>
                {legendDefinition.type === scaleTypes.CONTINUOUS &&
                    Array(100)
                        .fill()
                        .map((_, i) => (
                            <span
                                // eslint-disable-next-line react/no-array-index-key
                                key={i}
                                style={{
                                    width: '2px',
                                    height: '15px',
                                    backgroundColor: legendDefinition.scale(i),
                                }}
                            />
                        ))}
                {legendDefinition.type === scaleTypes.DISCRETE &&
                    legendDefinition.scale.map((entry, index) => (
                        <span
                            key={`${mapName}-${legendDefinition.minMax[index] || index}`}
                            style={getDiscreteLegendEntryStyle(
                                entry,
                                legendDefinition.scale.length
                            )}
                        />
                    ))}
            </Grid>
            <Grid
                item
                container
                justifyContent="space-between"
                sx={{ fontSize: '10px' }}
                flexWrap="nowrap"
            >
                {legendDefinition.minMax.map((e) => (
                    <span key={e}>{e}</span>
                ))}
            </Grid>
        </Grid>
    );
};

export default Legend;
